module.exports = __webpack_public_path__ + "static/media/search.620d8eea.svg";